const splitBeneficiaryName = (beneficiaryName) => {
  let firstName = '';
  let lastName = '';
  const spaceIndex = beneficiaryName.indexOf(' ');
  if (spaceIndex === -1 || spaceIndex === 0) {
    firstName = beneficiaryName;
  } else {
    firstName = beneficiaryName.substr(0, spaceIndex);
    lastName = beneficiaryName.substr(spaceIndex + 1);
  }
  return [firstName, lastName];
}

export default splitBeneficiaryName;